<template>
  <Badge
    :status="status"
  >
    {{ label }}
  </Badge>
</template>

<script setup>
import { computed } from 'vue';
import Badge from './Badge.vue';

const props = defineProps({
  bool: {
    type: Boolean,
    required: true,
  },
  yesLabel: {
    type: String,
    default: 'Yes',
  },
  noLabel: {
    type: String,
    default: 'No',
  },
});

const status = computed(() => props.bool ? 'success' : 'danger');
const label = computed(() => props.bool ? props.yesLabel : props.noLabel);
</script>
